import { render, staticRenderFns } from "./DatosPaciente.vue?vue&type=template&id=16e6fd7b&scoped=true&"
import script from "./DatosPaciente.vue?vue&type=script&lang=js&"
export * from "./DatosPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e6fd7b",
  null
  
)

export default component.exports